
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 50 50"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M24.1 10.7C23.5 8 21.1 6 18.2 6s-5.3 2-5.9 4.7h-9v2.5h9.1c.6 2.7 3 4.7 5.9 4.7s5.3-2 5.9-4.7h22.5v-2.5H24.1zm-5.8 4.7c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5c0 2-1.6 3.5-3.5 3.5zM34 19c-2.9 0-5.3 2.1-5.9 4.8H3.3v2.5h24.9c.6 2.7 3 4.7 5.9 4.7 2.9 0 5.3-2 5.9-4.7h6.8v-2.5H40c-.7-2.8-3.1-4.8-6-4.8zm0 9.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.5 3.5-3.5 3.5zM14.9 32.1c-2.9 0-5.3 2-5.9 4.7H3.3v2.5H9c.6 2.7 3 4.7 5.9 4.7 2.9 0 5.3-2 5.9-4.7h25.9v-2.5H20.8c-.6-2.7-3-4.7-5.9-4.7zm0 9.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.5 3.5-3.5 3.5z"}})])
          )
        }
      }
    